import {Component, AfterViewInit, EventEmitter, Output, Input} from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbCarouselConfig
} from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TranslateService } from '@ngx-translate/core';
import {GlobalStoreService} from "../../shared/_services/global-store.service";
import { environment } from 'src/environments/environment';
import {AuthenticationService} from "../../Login/_services/authentication.service";
import {FileStoreService} from "../../shared/_services/file-store.service";
import {PersonaleStoreService} from "../../Admin/_service/personale-store.service";
import {Permission} from "../../Login/_guards/Permission";
import {ActivatedRoute, Router} from "@angular/router";
import { Color, hsl } from "d3";
import { PusherService } from "../../Chat/pusher.service";
import { ToastrService } from "ngx-toastr";
import { ChatService } from "../../Chat/chat.service";
import { Howl } from 'howler';
import {ApiPathsService} from "../../api-paths.service";
import {GetCarrelloCount} from "../../../environments/Modules/Marketplace/ProductUtility"
import {ReverbService} from "../../reverb.service";

declare var $: any;

@Component({
  selector: 'app-vertical-navigation',
  templateUrl: './vertical-navigation.component.html'
})
export class VerticalNavigationComponent implements AfterViewInit {

  getCarrelloCount = GetCarrelloCount
  RichiesteCount:number = 0;
  environment = environment;
  @Output() toggleSidebar = new EventEmitter<void>();
  @Input() customizer: boolean = false;
  @Output() customizerChange = new EventEmitter<boolean>();
  public config: PerfectScrollbarConfigInterface = {};
  public selectedLanguage: any = {
    language: 'Italian',
    code: 'it',
    type: 'IT',
    icon: 'it'
  }
  openNotifiche=false;


  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: 'us'
    },
    {
      language: 'Español',
      code: 'es',
      icon: 'es'
    },
    {
      language: 'Français',
      code: 'fr',
      icon: 'fr'
    },
    {
      language: 'German',
      code: 'de',
      icon: 'de'
    },
    {
      language: 'Italian',
      code: 'it',
      icon: 'it'
    }
  ]
  notifiche: any[];
  private utenteAutenticatoId: number;
  private sound;
  public fullScreen = false;
  Messaggi: {
    id_destinatario: number;
    messaggio: string;
    letto: string,
    tipo?: string;
    file_name?: string;
    file_extension?: string;
    file_content?: string;
  }[];


  constructor(private modalService: NgbModal, private translate: TranslateService, public store: GlobalStoreService, public authenticationService: AuthenticationService,     private filestore: FileStoreService,
              private personaleStore: PersonaleStoreService,
              public permission: Permission,
              private route: ActivatedRoute,
    private reverb: ReverbService,
    private api: ApiPathsService,
    private router: Router,
    private toastr: ToastrService,
    private chatService: ChatService,
    private pusherService: PusherService
  ) {
    translate.setDefaultLang('it');
    this.sound = new Howl({
      src: ['assets/audio.mp3']
    });

  }
  showNotificationToastr(name: string): void {
    const senderName = name;

    const toastrOptions = {
      closeButton: true,
      timeOut: 5000,
      extendedTimeOut: 2000
    };

    this.toastr.info(
      `<div class="d-flex align-items-center">
         <div class="me-3">
           <i class="fas fa-bell fa-3x"></i>
         </div>
         <div>
           <div class="fw-bold pl-2"><strong>${senderName}</strong></div>
           <div class="text-nowrap overflow-hidden text-truncate pl-2" >Ti ha scritto</div>
         </div>
       </div>`,
      '',
      {
        enableHtml: true,
        toastClass: 'ngx-toastr',
        timeOut: toastrOptions.timeOut,
        extendedTimeOut: toastrOptions.extendedTimeOut
      }
    );
  }
  changeLanguage(lang: any) {
    this.translate.use(lang.code)
    this.selectedLanguage = lang;

  }

  async ngAfterViewInit() {
    this.store.GetAllNotifications();
    this.store.$notifiche.subscribe(notifiche => this.notifiche = notifiche)
    if(environment['style'] == 'Marketplace' && this.permission.isOperativeRoles(['C'])){
      this.store.getCartData();
      this.store.$cartData.subscribe(cartData => {
          console.log("Cart Data: ", cartData);
          this.RichiesteCount = cartData?.richieste
        }
      );
      for (let i = 0; i < 10; i++) {
        this.notifiche.push({
          id: i,
          title: `Notifica ${i}`,
          message: `Questo è un messaggio di notifica ${i}`,
          value: `Notifica ${i}`,
        })
      }
    }


    this.store.$fullscreen.subscribe(fullscreen => this.fullScreen = fullscreen)
    if (this.environment['chatApiUrl']){
    const currentUserString = localStorage.getItem('currentUser');
    if (currentUserString) {
      const currentUser = JSON.parse(currentUserString);
      this.utenteAutenticatoId = currentUser.id;
    }
    this.chatService.getUnreadMessages(1, 20).subscribe(data => {
      this.Messaggi = data.messages;
      console.log("Messaggi: ", data);
    })
    this.pusherService.subscribe('chat-channel', 'new-message', (data: any) => {
      if ((data.message.id_mittente != this.utenteAutenticatoId) && (data.message.id_destinatario == this.utenteAutenticatoId)) {
        this.chatService.getUser(data.message.id_mittente).subscribe(
          data => {
            console.log("Emetto il toastr");
            this.showNotificationToastr(data.utente.username);
            this.sound.play();
          },
          error => {
            console.log("Errore nel recupero dell'utente");
          }
        )
      }
      this.chatService.getUnreadMessages(1, 20).subscribe(data => {
        this.Messaggi = data.messages;
        console.log("Messaggi: ", data);
      })
    });}
    console.log('Avvio reverb...', this.authenticationService.currentUserValue)
    this.reverb.connect();
    await this.reverb.subscribeToNotifyChannel();
    this.reverb.events$
      .subscribe(msg => {

        if (
          msg.type === 'EVENT' &&
          msg.event === 'new-notification'
        ) {
          this.toastr.success(msg.data.message,  "", {toastClass:'marketplace-success-toast'});
          this.store.GetAllNotifications();
          this.sound.play();
          console.log(msg.data);

        }

      });


  }

  RichiesteClick(){
    this.store.toggleCart()
  }
  CarrelloClick(){
    this.store.togglecarrelloCart();
  }

  LogOut() {
    this.authenticationService.logout();
  }
  Profilo() {
    if(this.environment['style'] == 'Marketplace'){
      this.router.navigate([this.route.snapshot.queryParams['marketplace/profilo'] || 'marketplace/profilo',]) //cambialo qui
      return;
    }
    if(this.permission.isOperativeRoles(environment.ClientiType)) {
      this.router.navigate([this.route.snapshot.queryParams['Cliente/profile'] || 'Cliente/profile',])
      return;
    }
    this.personaleStore.updateEditable(true);
    this.personaleStore.updateShowAddForm(false);
    this.personaleStore.updateSelectedUserWhenProfile(this.authenticationService.currentUserValue);
    this.filestore.SelectSection('Profilo');
    this.router.navigate([this.route.snapshot.queryParams[' listautenti/profilo '] ||'listautenti/profilo',])
  }
  LightenColor(color: string, percent = 50) {
    if (!color || !color.includes('#'))  return hsl(0, 0, 100);
    var num = parseInt(color.toString().replace("#", ""), 16);
    if (num < 16750000)
      return hsl(0, 0, 100);
    else
      return hsl(0, 0, 0);
  };

  toggleFullScreen(){
    this.store.setFullScreen(!this.fullScreen);
  }
  HeaderActionClick(action) {
    if (action.link)
      window.open(action.link);
  }


}
